
const Container = ({ children, v2 = false }) => {
	if (v2) return (
		<div className="containerv2 mx-auto">
			{children}
		</div>
	)
	return (
		<div className="container px-2 sm:px-0 mx-auto">
			{children}
		</div>
	)
}

export default Container